
export const TOKEN = 'token';
export const USER_NAME = 'userName';
export const CHEMSPIDER_KEY = 'chemspiderKey';
export const SELECTED_CONTAINER_NAME = 'selectedContainerName';
export const SELECTED_CONTAINER = 'selectedContainer';
export const EDITOR_SMILES = 'editorSmiles';
export const EDITOR_BACK = 'editorBack';
export const EDITOR_ITEM = 'editorItem';
export const EDITOR_NEW_BLOCK_NAME = 'editorBlockNewName';
export const EDITOR_NEW_BLOCK_ACRONYM = 'editorBlockNewAcronym';
export const EDITOR_NEW_BLOCK_FORMULA = 'editorBlockNewFormula';
export const EDITOR_NEW_BLOCK_SMILES = 'editorBlockNewSmiles';
export const ADMIN = 'admin';


export const SEQUENCE_ID = 'sequenceId';
export const SEQUENCE_EDIT = 'sequenceEdit';

export const CONTAINER = 'container';
export const SFAMILY = '/family';
export const SMODIFICATION = '/modification';
export const SBLOCK = '/block';
export const SSEQUENCE = '/sequence';

export const ELEMENT_LARGE_SMILES = 'popupLargeSmiles';
